import { render } from "./ItemTitle.vue?vue&type=template&id=96a3b408&scoped=true&ts=true"
import script from "./ItemTitle.vue?vue&type=script&lang=ts"
export * from "./ItemTitle.vue?vue&type=script&lang=ts"

import "./ItemTitle.vue?vue&type=style&index=0&id=96a3b408&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a3b408"]])

export default __exports__